module.exports = __webpack_public_path__ + "static/media/terrace.9dd93f91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/objects/generalInformation/terrace.svg
// module id = 302
// module chunks = 0